<div style="background-color: white">
  <div class="container">
    <div class="input-wrapper">
      <div class="left-section">
        <h1 class="heading">
          <span class="highlight">Strengthen Your</span> <br />
          Digital Presence<span class="dot">.</span>
          <img src="../../../assets/images/mall-star2.png" class="image1" />
          <img src="../../../assets/images/small-star1.png" class="image2" />
        </h1>
        <p>
          create a professional school website with powerfull tools for easy
          updates, showcasing achievements, and engaging with parents.
        </p>
        <button>Get Your Schools Website</button>
        <div *ngIf="logoUrl?.length">
          <div class="carousel-container">
            <div class="carousel-images">
              <!-- <ng-image-slider
                [imageSize]="getImgSize()"
                [autoSlide]="autoSlide"
                [infinite]="infiniteSlide"
                [showArrow]="false"
                [animationSpeed]="1"
                [images]="logoUrl"
                #gallery
              ></ng-image-slider> -->
              <div class="marquee-wrapper">
                <om-marquee [animationDuration]="'40s'">
                  <div
                    class="marquee-card"
                    *ngFor="let logo of logoUrl"
                    #OmMarqueeContent
                  >
                    <img [src]="logo.url" class="school-logos" />
                  </div>
                </om-marquee>
                <div class="marquee-gradient left"></div>
                <div class="marquee-gradient right"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="right-section">
        <div class="image-wrapper">
          <img src="../../../assets/images/public-page.png" alt="image" />
        </div>
      </div>
    </div>
  </div>
  <div class="websites-wrapper">
    <div class="compiant-header">
      <h2>
        Make your Website <br />
        <span>Government Compliant</span>
      </h2>
      <a> Create Your School Website →</a>
    </div>
    <div class="image-gallery" #gallery>
      <div class="image-item" *ngFor="let image of images1">
        <img [src]="image.url1" alt="Gallery Image" />
      </div>
    </div>
    <div class="image-gallery" #gallery>
      <div class="image-item" *ngFor="let image of images1">
        <img [src]="image.url2" alt="Gallery Image" />
      </div>
    </div>
  </div>
  <div class="intro-wrapper">
    <h2>Its as easy as 1 click!</h2>
    <p>
      Whether you're building a new website or imporving an existing one, we'll
      create your entire school site-including a streamlined admission
      funnel-with just one click!
    </p>
    <button>Create Your School Website now →</button>
  </div>
  <div class="container">
    <div class="platform-header">
      <div class="ph-right">
        <h2>
          How Inforida <span class="highlights">Elevates</span><br />
          <span class="highlights">Your</span> school Website.
        </h2>
      </div>
      <div class="ph-left">
        <a href="#" class="learn-more">Create Your Schools Website →</a>
      </div>
    </div>
    <div class="cards-container">
      <div class="card" *ngFor="let card of paublicFeatures">
        <div class="card-image">
          <div
            class="background-image"
            [style.background-image]="'url(' + card.imageUrl + ')'"
          ></div>
        </div>
        <div class="card-text">
          <h3 class="card-title">{{ card.heading }}</h3>
          <p class="card-description">{{ card.description }}</p>
        </div>
      </div>
    </div>
  </div>
  <!-- <app-cards-wrap
    heading1="How Inforida"
    heading2="Elevates"
    heading3="Your"
    heading4="School Website"
    subheading="Create Your Schools Website →"
    [array]="paublicFeatures"
  ></app-cards-wrap> -->
  <div class="infra-wrapper">
    <div class="compiant-header">
      <h2>
        Make your Website <br />
        <span>Government Compliant</span>
      </h2>
      <a> Create Your School Website →</a>
    </div>
    <div class="infra-cards">
      <div class="infra-card" *ngFor="let card of infraCards">
        <img [src]="card.url" />
      </div>
    </div>
  </div>
  <div class="compiant-wrapper">
    <div class="compiant-header">
      <h2>
        Make your Website <br />
        <span>Government Compliant</span>
      </h2>
      <a> Create Your School Website →</a>
    </div>
    <div class="top-section">
      <div class="left-tp-section">
        <img src="../../../assets/images/public-disclosure.png" />
      </div>
      <img src="../../../assets/images/luck.png" />
    </div>
    <div class="lottie-wrapper">
      <div class="lottie-image">
        <div class="circle-image">
          <!-- <ng-lottie
            [options]="lottieTree"
            [height]="'487.11px'"
            [width]="'274px'"
            (animationCreated)="animationCreated($event)"
          ></ng-lottie> -->
          <lottie-player
            src="../../../assets/lottie/public-page.json"
            background="transparent"
            speed="8"
            style="width: 274px; height: 487.11px"
            loop
            autoplay
          >
          </lottie-player>
        </div>
      </div>
      <div class="lottie-text">
        <h2>
          Already Have a website? <br />
          <span> Import Data</span> with one click
        </h2>
        <p>
          use out One-click import tool to instantly transfer all your school
          details to inforida. Save time and effort while seamlessly bringing
          your data to our platform for a smooth and efficient setup.
        </p>
        <a>Transfer Your Website →</a>
      </div>
    </div>
  </div>
</div>
